import { getLayout } from './utils/layout';

import type { ResizeGapsScope } from './resizeGapsScope';
import type { Gap } from './resizeGapsTypes';

export interface Transition {
  update({ deltaY }: { deltaY: number }): void;

  end(): void;
}

export const createTransition = (
  resizeGapsScope: ResizeGapsScope,
  gap: Gap,
): Transition => {
  const { editorAPI, compPointersApi } = resizeGapsScope;

  if (!gap.componentBelow) {
    const resizeToAndPushTransition =
      editorAPI.components.layout.resizeToAndPushTransition(
        compPointersApi.withCurrentContext(gap.container),
      );
    const initialHeight = getLayout(editorAPI, gap.container).height;

    return {
      end: resizeToAndPushTransition.end,
      update: ({ deltaY }) =>
        resizeToAndPushTransition.update({ height: initialHeight + deltaY }),
    };
  }

  const moveByAndPushTransition =
    editorAPI.components.layout.moveByAndPushTransition(
      compPointersApi.withCurrentContext(gap.componentBelow),
    );

  return {
    update: moveByAndPushTransition.update,
    end: moveByAndPushTransition.end,
  };
};
